<div class="PnInput">
  <label style="text-align: left; flex: 1; width: 100%">
    <span class="PnInput-label">{{ label }}</span>

    <div class="PnInput-fieldContainer">
      <input
        class="PnInput-field"
        [ngClass]="{ 'is-error': error }"
        [type]="type"
        [required]="required"
        [name]="name"
        [value]="value"
        [(formControl)]="control"
        data-test-field
      />
    </div>
  </label>

  <div *ngIf="error" class="PnInput-error" data-test-error>
    {{ error }}
  </div>

  <div *ngIf="showForgotPassword">
    <a href="/users/password/new" class="PnInput-label-link">
      Forgot password?
    </a>
  </div>
</div>
